import { useAppInsightsPageViewTracker } from "core/analytics/app-insights/app-insights.hooks";
import { useGoogleAnalyticsPageTracking } from "core/analytics/google-analytics/google-analitics.hooks";
import { useDocumentTitle } from "core/hooks/useDocumentTitle";

import { logout, useUserInactivity } from "@bps/msal";

import { config } from "../core/config";

export const AppTrackers = () => {
  useUserInactivity(
    () => logout({ postLogoutRedirectUri: window.location.href }),
    {
      timeoutMins: config.userInactivityTimeoutMins
    }
  );

  /* useDocumentTitle must run before useAppInsightsPageViewTracker as it depends on the document title*/
  useDocumentTitle();
  useAppInsightsPageViewTracker();
  useGoogleAnalyticsPageTracking();

  return null;
};
